
var utils = require("!!/home/slavas/WORK/code/dashblocks/node_modules/@finos/perspective-webpack-plugin/src/js/utils.js");
module.exports = utils.publicPath(__webpack_public_path__) + "psp.async.wasm";